;(() => {
  window.HB = window.HB || {}
  window.HB.initMapTypesSwitcher = function (gmap) {
    document
      .querySelector(".gmap-types-switcher")
      ?.addEventListener("click", function (event) {
        event.preventDefault()
        this.dataset.currentType =
          this.dataset.currentType === "roadmap" ? "satellite" : "roadmap"
        gmap.setMapTypeId(this.dataset.currentType)
      })
  }
})()
